import Dexie, { Table } from 'dexie';
import { IPostalCodeImport } from '../Models';
import { PostalCodesService } from '../Services/PostalCodesService';

export class CityDatabase extends Dexie {
    public city!: Table<IPostalCodeImport, number>;

    constructor() {
        super('CityDatabase');

        this.version(2).stores({
            city: '++id, postalCode, postalCodeString, nameFR, nameNL',
        });

        this.on('populate', async () => {
            const postalCodes = await PostalCodesService.getAllPostalCodes();
            await this.city.bulkPut(postalCodes);
        });
    }
}

export const cityDb = new CityDatabase();
